import React from "react";

import "./ErrorPopup.css";

import WithPopup from "./../../../HOC/WithPopup/WithPopup";
import { Heading, Text, RedButton } from "./../../../StyledComponents";
import { CancelIcon, ErrorIcon } from "../Svg";

export default (props) => {
  const containerRef = React.useRef();
  const [popupBackdropStyle, setPopupBackdropStyle] = React.useState(null);

  const cancleClickHandler = () => {
    setPopupBackdropStyle({
      animation: "fade-out-blackdrop 0.2s ease-out forwards",
    });
    containerRef.current.classList.add("error-popup__container-out");
    setTimeout(props.onCancelClick, 200);
  };

  const okayClickHandler = () => {
    setPopupBackdropStyle({
      animation: "fade-out-blackdrop 0.2s ease-out forwards",
    });
    containerRef.current.classList.add("error-popup__container-out");
    setTimeout(props.onOkayClick, 200);
  };

  return (
    <WithPopup backdropStyle={popupBackdropStyle}>
      <div
        className="error-popup__wrapper"
        automationid="SalesLead_Div_exit-confirmation_1"
      >
        <div
          ref={containerRef}
          className="error-popup__container"
          automationid="SalesLead_Div_exit-confirmation_2"
        >
          <div
            onClick={cancleClickHandler}
            className="error-popup__btn-close"
            automationid="SalesLead_Div_exit-confirmation_4"
          >
            <CancelIcon width="0.3" size="large" />
          </div>
          <ErrorIcon />
          <Heading
            style={{ fontSize: "20px", color: "black" }}
            automationid="SalesLead_H1_exit-confirmation_1"
          >
            Oops...
          </Heading>
          <Text
            color="black"
            aligntext="center"
            automationid="SalesLead_P_exit-confirmation_1"
          >
            {props.children}
          </Text>
          <div className="error-popup__btn-container">
            <RedButton
              automationid="SalesLead_Button_exit-confirmation_2"
              onClick={okayClickHandler}
            >
              Okay
            </RedButton>
          </div>
        </div>
      </div>
    </WithPopup>
  );
};
